import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import LandingPage from './pages/LandingPage';
import ResultsPage from './pages/ResultsPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import OnboardingPage from './pages/OnboardingPage';

/**
 * ResultsRouter component - handles special case for 'auth' route
 * Renders ResultsPage only if the postcodeOrUsername parameter is not 'auth'
 */
function ResultsRouter() {
  const { postcodeOrUsername } = useParams();
  
  // If route parameter is 'auth', don't render ResultsPage (this route will be handled by auth routes)
  if (postcodeOrUsername === 'auth') {
    return null;
  }
  
  // Otherwise, render ResultsPage normally
  return <ResultsPage />;
}

/**
 * TradesPurple routing component
 * 
 * Routes:
 * - /tradespurple -> LandingPage
 * - /tradespurple/auth/* -> Auth routes (special reserved path)
 * - /tradespurple/:postcodeOrUsername -> ResultsPage (except when postcodeOrUsername is 'auth')
 * - /tradespurple/:postcodeOrUsername/:tradeType -> ResultsPage with category filter
 * 
 * The routes are public but may render different content based on authentication status.
 */
export default function TradesPurpleRoutes() {
  const { isAuthenticated, user } = useAuth();
  
  return (
    <Routes>
      {/* Special auth routes that take precedence */}
      <Route path="/auth/login" element={<LoginPage />} />
      <Route path="/auth/signup" element={<SignupPage />} />
      <Route path="/auth/onboarding" element={<OnboardingPage />} />
      
      {/* Standard routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/:postcodeOrUsername" element={<ResultsRouter />} />
      {/* Route for sharing specific tradesperson - MUST come before generic route */}
      <Route path="/:postcodeOrUsername/tradesperson/:tradespersonId" element={<ResultsRouter />} />
      {/* Generic route for trade type filtering */}
      <Route path="/:postcodeOrUsername/:tradeType" element={<ResultsRouter />} />
      
      {/* Redirect any unmatched routes to the landing page */}
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}
